import { render, staticRenderFns } from "./DayOffRequests.vue?vue&type=template&id=bb36fad8"
import script from "./DayOffRequests.vue?vue&type=script&lang=js"
export * from "./DayOffRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports